/*
  created by Rija
  added on 2/1/2021
  @desc meter main page to swtich between different options
*/

import React, { Component, createRef } from 'react';
import { Route } from 'react-router-dom';
import { ButtonGroup, Button } from 'react-bootstrap';
import { ColorButton, FiltersContainer, HeadingContainer, SearchContainer } from '../../../../neoverv';
import Autoload from '../../../../neoverv/Autoload';
import { withRouter } from 'react-router-dom';
import MessagingEditor from './MessagingEditor';
import { IconButton, TableContainer, Tooltip } from '@material-ui/core';
import { Group, Input, Popover, Select, Stack, Text } from '@mantine/core';
import Up from '../../../../assets/images/module/general/SelectArrowUp.svg';
import Down from '../../../../assets/images/module/general/SelectArrowDown.svg';
import PrintIconBlue from '../../../../assets/images/module/general/PrintIconBlue.svg';
import PrintIconWhite from '../../../../assets/images/module/general/PrintIconWhite.svg';
import MessagingEditorMantine from './MessagingEditorMantine';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import moment from 'moment';
import ReplyIcon from '@material-ui/icons/Reply';
import ReplyAllIcon from '@material-ui/icons/ReplyAll';
import breadcrumbsContent from '../../../../../src/assets/breadcrumbs.json';
import HelpLogo from '../../../../assets/images/module/general/book.svg';
import TourIcon from '../../../../assets/images/module/general/TourIcon.svg';
import BlueTick from '../../../../assets/images/module/general/BlueTick.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import YellowTick from '../../../../assets/images/module/general/YellowTick.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import RightArrowPartner from '../../../../assets/images/module/general/RightArrowPartner.svg';
import ExplanationMarkIcon from '../../../../assets/images/module/general/ExplanationMarkIcon.svg';
import CrossIcon from '../../../../assets/images/module/general/CrossIcon.svg';
import { connect } from 'react-redux';
import MessagePreviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePreviewModal';
import SelectMessageRecipientToPrint from '../../../../neoverv/components/Module/General/CustomModal/SelectMessageRecipientToPrintModal';
import MessagePostviewModal from '../../../../neoverv/components/Module/General/CustomModal/MessagePostviewModal';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DescriptionIcon from '@material-ui/icons/Description';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import dayjs from 'dayjs';
import { config } from '../../../../neoverv/config/Setting';
import { getAuthToken } from '../../../../neoverv/helpers/Utils';
import BulkDownloadForMessageModal from '../../../../neoverv/components/Module/General/CustomModal/BulkDownloadForMessageModal';
import DownloadIcon from '../../../../assets/images/module/general/DownloadIconBlue.svg';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { loader, checkProperty, checkEnvironment, errorHandlingForPDF } = Autoload.MainHelper;

const MOBILE_SIZE = 992;

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin

class TenantMessageDetail extends Component {

  state={
    openRecipientStatus: null,
    openPreviewModal: false,
    openSelectMessageRecipientToPrintModal: false,
    selectedRecipient: null,
    selectedMessageErrorPopover: null,
    scrollX: 0,
    maxScrollX: 400,
    isOverflowing: false,
    hover: null,
    openBulkMessageDownloadModal: false,
    selectedMessageForBulkDownload: null
  }

  constructor(props) {
    super(props);
    this.divRef = createRef();
    const html = '<h1 style="text-align:center;">Hellohousing Message</h1><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p><p style="font-weight:400;">Lorem ipsum dolor sit amet. Sed dolorem eius a quia odio ad architecto ullam non quia sunt et rerum harum. Eum eius molestiae aut provident placeat sed rerum facere in velit repellendus qui illum enim non perferendis officia.</p><p style="font-weight:400;">Et nostrum labore qui laborum aspernatur sed alias ullam aut laudantium velit et omnis dolor qui sint quia. Non porro voluptatem sit amet necessitatibus qui enim nostrum ad impedit fuga et expedita suscipit. Qui galisum itaque in nisi modi et beatae omnis vel voluptatem corporis ea earum incidunt At architecto minima!</p><p style="font-weight:400;">Eos ipsa quaerat est officiis perspiciatis eos omnis perferendis. Sed quas dolores vel nemo officia et molestiae tenetur cum galisum molestiae.</p>';
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      const content = EditorState.createWithContent(contentState);
      console.log('content: ', contentBlock);
      this.state = {
        ...this.state,
        content,
        html,
        isMobile: window.innerWidth <= MOBILE_SIZE,
        //message: props.location.state.message
      };
    }
  }

  componentDidMount(){
    dayjs.extend(utc);
    dayjs.extend(timezone);
    window.addEventListener('resize', this.handleResize);
    // const scrollableDiv = window.document.getElementById('message-recipients-list-container')
    // const originalWidth = scrollableDiv.scrollWidth;
    // this.setState({maxScrollX: originalWidth});

    //this.checkOverflow();
    //window.addEventListener("resize", this.checkOverflow);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
    //window.removeEventListener("resize", this.checkOverflow);
  }

  checkOverflow = () => {
    if (this.divRef.current) {
      this.setState({
        isOverflowing: this.divRef.current.scrollWidth > this.divRef.current.clientWidth,
      });
    }
  };

  handleResize = () => {
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  };

  downloadPdfFromServer=()=>{
    console.log('downloadPdfFromServer:');
    const data = new FormData();
    let html = document.getElementById('message-body');
    let doc = document.implementation.createHTMLDocument("New Document");
    try {
      doc.body.appendChild(html);
      const blob = new Blob([doc.documentElement.innerHTML], {
        type: 'text/html'
       });
      
      const fileName = `messagingTemplate2-${this.props.propertySelected.name}-${new Date().valueOf()}}`;
      let file = new File([blob], fileName);
      file.originalname = fileName;
      console.log('downloadPdfFromServer: ', file);
      data.append('file', file);
      let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
      fetch(url,
        {
          method: 'POST',
          body: data,
          headers: {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        }).then((response)=> {
          if(response.status === 200){
            response.blob()
            .then(data => {
              //download progress
              var a = document.createElement("a");
              document.body.appendChild(a);
              let url = window.URL.createObjectURL(data);
              a.href = url;
              a.download = 'test.pdf';
              a.click();
              window.URL.revokeObjectURL(url);
            })
          }else{
            errorHandlingForPDF(response, this.props.profileData, url);
          }
        });
    } catch (e) {
      console.log('downloadPdfFromServer: ', e);
    }
  }

  replaceValuesWithPlaceHolders=(html)=>{
    let newHtml= html;

    newHtml= newHtml.replaceAll('{{TENANT_OCCUPATION_BILLING_PERIOD}}', '<a href="#" target="_self">Abrechnungszeitraum</a>');
    newHtml= newHtml.replaceAll('{{BILLING_PERIOD}}', '<a href="#" target="_self">Abrechnungszeitraum</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ALLOCATED_UTILITY_COSTS}}', '<a href="#" target="_self">Betriebskosten</a>');
    newHtml= newHtml.replaceAll('{{BILLING_STATEMENT_BALANCE}}', '<a href="#" target="_self">Guthaben / Nachzahlung</a>');
    newHtml= newHtml.replaceAll('{{RECIPIENT_NAME}}', '<a href="#" target="_self">Empfänger</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_UNIT_NAME}}', '<a href="#" target="_self">Mieteinheit</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_STREET}}, {{PROPERTY_ZIPCODE}} {{PROPERTY_CITY}}', '<a href="#" target="_self">Objektadresse</a>');
    newHtml= newHtml.replaceAll('{{TOTAL_ADVANCE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlungen</a>');

    //new
    newHtml= newHtml.replaceAll('{{TENANT_NAME}}', '<a href="#" target="_self">Mieter</a>');
    newHtml= newHtml.replaceAll('{{USER_FIRST_NAME}} {{USER_LAST_NAME}}', '<a href="#" target="_self">Absender</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_OUT_DATE}}', '<a href="#" target="_self">Auszugsdatum</a>');
    newHtml= newHtml.replaceAll('{{TENANT_MOVE_IN_DATE}}', '<a href="#" target="_self">Einzugsdatum</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_RECEIVED_RENT}}', '<a href="#" target="_self">erhaltene Miete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_EXPECTED_RENT_TOTAL}}', '<a href="#" target="_self">gesamte ausstehende Miete</a>');
    newHtml= newHtml.replaceAll('{{COLD_RENT}}', '<a href="#" target="_self">Kaltmiete</a>');
    newHtml= newHtml.replaceAll('{{RENTAL_PAYMENT_MONTH}}', '<a href="#" target="_self">Mietmonat</a>');
    newHtml= newHtml.replaceAll('{{ACCOUNT_COMPANY_NAME}}', '<a href="#" target="_self">Vermieter</a>');
    newHtml= newHtml.replaceAll('{{RENT_PRE_PAYMENTS}}', '<a href="#" target="_self">Vorauszahlung</a>');
    newHtml= newHtml.replaceAll('{{WARM_RENT}}', '<a href="#" target="_self">Warmmiete</a>');

    newHtml= newHtml.replaceAll(`https://${window.location.href.includes('app') ? 'app' : 'dev'}.hellohousing-mieterportal.de/signup?{{SIGNUP_CODE}}`, '<a href="#" target="_self">Zugangslink</a>');
    newHtml= newHtml.replaceAll('{{PROPERTY_OWNER_NAME}}', '<a href="#" target="_self">Eigentümer</a>');

    return newHtml;
  }

  renderReplyAndForwardButton=()=>{
    const {message} = this.props.location.state;
    return (
      <Group wrap="nowrap">
        <Tooltip title="PDF herunterladen" >
          <IconButton 
          aria-label="filter list"
          onClick={()=> this.setState({openBulkMessageDownloadModal: true, selectedMessageForBulkDownload: message})}
            style={{
              background: 'white', 
              border: '1px solid #DADAE5', 
              boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
              padding: '5px'
            }}>
            <img
            src={DownloadIcon} 
            style={{
              width: '15px',
              height: '15px',
            }}/>
          </IconButton>
        </Tooltip>
        <Tooltip title="Allen antworten" >
          <IconButton 
          aria-label="filter list"
          onClick={()=> this.props.history.push('/messaging/newMessage', {message: {
            ...message,
            id: null,
            utilityBillingId: null,
            subject: this.replaceValuesWithPlaceHolders(message.subject),
            body: null,
            }, 
            recipients: message.recipients,
            replyAll: true
          })}
          style={{
            background: 'white', 
            border: '1px solid #DADAE5', 
            boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
            padding: '5px'
            }}>
            <ReplyAllIcon 
            style={{
                color: '#5655FE', 
                width: '15px',
                height: '15px'
            }}
            />
          </IconButton>
        </Tooltip>
        {!message.utilityBillingId &&
        <Tooltip title="Weiterleiten" >
          <IconButton 
          aria-label="filter list" 
          onClick={()=> this.props.history.push('/messaging/newMessage', {
              message: {
              ...message,
              id: null,
              recipients: [],
              body: this.replaceValuesWithPlaceHolders(message.body),
              subject: this.replaceValuesWithPlaceHolders(message.subject)
              }, 
              recipients: null,
              forward: true
          })}
          style={{
            background: 'white', 
            border: '1px solid #DADAE5', 
            boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
            padding: '5px'
            }}>
            {/* <img
            src={ReplyIcon} 
            style={{
              width: '15px',
              height: '15px',
              }}/> */}
            <ReplyIcon 
            className='forward-icon'
            style={{
                color: '#5655FE', 
                width: '15px',
                height: '15px'
            }}
            />
          </IconButton>
        </Tooltip>}
      </Group>
    )
  }

  renderMessageRecipients=()=>{
    const {message} = this.props.location.state;
    const {openRecipientStatus} = this.state;
    return (
      message && message.recipients.map((recipient, index)=> 
      recipient.name &&
      <Popover
  opened={openRecipientStatus === recipient.id}
  position="top"
  withArrow
  transitionProps={{ duration: openRecipientStatus === null ? 1000 : 500 }} // 1. Grouped transition props
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Group 
      onClick={() => message.status !== 'Failed' && this.setState({ openPreviewModal: true, selectedRecipient: recipient.id })} 
      onMouseEnter={() => this.setState({ openRecipientStatus: recipient.id })} 
      onMouseLeave={() => this.setState({ openRecipientStatus: null })}
      gap={5} 
      className="message-card-ten-cards" 
      style={{
        height: '20.6px', 
        maxHeight: '20.6px', 
        background: 'white', 
        paddingRight: message.status !== 'Draft' ? '3px' : '10px', 
        overflowX: 'scroll'
      }}
      wrap="nowrap"
    >
      <Group style={{ background: '#454576', width: '18px', minWidth: '18px', borderRadius: '120px' }} justify="center" align="center">
        <span style={{ textTransform: 'capitalize', color: 'white' }}>{recipient.name[0]}</span>
      </Group>
      <span style={{ whiteSpace: 'nowrap' }}>{recipient.name}</span>
      {message.status !== 'Draft' && (
        <Group>
          <img 
            style={{ minWidth: '16px' }} 
            src={((recipient.isPostEnabled && (recipient.postalStatus === 'Failed' || recipient.postalStatus === 'Verarbeitungsfehler')) || (recipient.isEmailEnabled && recipient.emailStatus === 'Failed')) ? ExplanationMarkIcon : (recipient.isPostEnabled && recipient.postalStatus === 'Publish') ? YellowTick : GreenTick}
            alt="Status Indicator"
          />
        </Group>
      )}
    </Group>
  </Popover.Target>

  {/* 3. Dropdown Wrapper */}
  <Popover.Dropdown p="xs">
    {message.status === 'Failed' ? (
      <span style={{ fontSize: '12px', fontWeight: '400' }}>
        Es ist ein Fehler bei der Übermittlung der Nachricht aufgetreten. Die Nachricht konnte nicht gesendet werden. Wenden Sie sich bei Fragen an den Kundenservice.
      </span>
    ) : (
      <Stack 
        gap={10} 
        style={{ fontSize: '12px', fontWeight: '400' }}
        onMouseEnter={() => this.setState({ openRecipientStatus: recipient.id })}
        onMouseLeave={() => this.setState({ openRecipientStatus: null })}
      >
        <Stack gap={10}>
          {recipient.isPostEnabled && (
            <Group gap={5}>
              <span>Briefversand:</span>
              {recipient.postalStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.postalStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.postalStatus === 'Verarbeitungsfehler' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.postalStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.postalStatus === 'Failed' ? <span>Übertragungsfehler</span> : ''}
              {recipient.postalStatusMessage && <span>{recipient.postalStatusMessage}</span>}
            </Group>
          )}
          {recipient.isEmailEnabled && (
            <Group gap={5}>
              <span>Email-Versand:</span>
              {recipient.emailStatus === 'Publish' ? <img src={YellowTick} alt="status" />
              : recipient.emailStatus === 'Sent' ? <img src={GreenTick} alt="status" />
              : recipient.emailStatus === 'Error' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Failed' ? <img src={RedCross} alt="status" />
              : recipient.emailStatus === 'Draft' && <img src={YellowTick} alt="status" />}
              {recipient.emailStatus === 'Failed' ? <span>Übertragungsfehler</span> : recipient.emailStatus === 'Sent' ? 'Nachricht übermittelt' : ''}
            </Group>
          )}
          {recipient.isHiddenForTenantPortal === false && (
            <Group gap={5}>
              <span>Mieterportal:</span>
              <img src={GreenTick} alt="status" />
              <span>Nachricht übermittelt</span>
            </Group>
          )}
        </Stack>
        <Group onClick={() => this.setState({ openPreviewModal: true, selectedRecipient: recipient.id })}>
          <span style={{ color: '#5555FF', cursor: 'pointer' }}>
            Empfängernachricht anzeigen <img src={RightArrowPartner} style={{ width: '12px', marginLeft: '2px' }} alt="arrow" />
          </span>
        </Group>
      </Stack>
    )}
  </Popover.Dropdown>
</Popover>
      
      )
    )
  }

  renderMessageRecipientsContainer=()=>{
    const {scrollX, maxScrollX, isMobile, isOverflowing} = this.state;
    const {message} = this.props.location.state;
    return (
    <Group gap={10} wrap="nowrap" justify="space-between">
      {(message.recipients.length > 1 && isOverflowing) &&
      <Group 
        onClick={()=> {
          let container = window.document.getElementById('message-recipients-list-container');
          if(scrollX >= 100){
            container.scrollTo({left: scrollX-100, top: 0, behavior: 'smooth'});
            this.setState({scrollX: scrollX-100});
          }
        }}
        onDoubleClick={()=>{
          let container = window.document.getElementById('message-recipients-list-container');
          container.scrollTo({left: 0, top: 0, behavior: 'smooth'});
          this.setState({scrollX: 0});
        }}
        style={{opacity: scrollX <= 0 ? 0.5 : 1, marginBottom: 0, padding: 0}}
        className={'chevron-button'}
        >
          <ChevronLeftIcon
          style={{
            color: '#000'
          }}
          />
      </Group>}
      <Group id='message-recipients-list-container' ref={this.divRef} className='messages-list-recipients' style={{maxWidth: !isMobile && '620px', overflowX: 'scroll', width: isMobile && '100%'}} wrap="nowrap">
        {this.renderMessageRecipients()}
      </Group>
      {(message.recipients.length > 1 && isOverflowing) &&
      <Group 
      className={'chevron-button'}
      style={{opacity: scrollX >= maxScrollX ? 0.5 : 1, marginBottom: 0, padding: 0}} 
      onClick={()=> {
      let container = window.document.getElementById('message-recipients-list-container');
      if(scrollX < maxScrollX){
      container.scrollTo({left: scrollX+100, top: 0, behavior: 'smooth'});
      this.setState({scrollX: scrollX+100});
      }
      }}
      onDoubleClick={()=>{
      let container = window.document.getElementById('message-recipients-list-container');
      container.scrollTo({left: maxScrollX, top: 0, behavior: 'smooth'});
      this.setState({scrollX: maxScrollX});
      }}>
      <ChevronRightIcon
      style={{
      color: '#000'
      }}
      />
      </Group>}
    </Group>
    )
  }

  renderCross=()=>{
    const {currentMessageData} = this.props;
    return(
      <img src={CrossIcon} alt='cross-icon' id={'utility-message-draft-3'} style={{cursor: 'pointer'}} onClick={()=>{
        loader(true);
        setTimeout(() => {
          loader(false);
          if(currentMessageData?.templateType === 'RentalPayment'){
            this.props.history.push('/user/rentIncomeTracking');
          }else if(currentMessageData?.templateType === 'TenantSignUp'){
            this.props.history.push('/tenantPortal');
          }else{
            this.props.history.push('/messaging/messages');
          }
          //this.props.history.push(window.location.href.includes('/newMessage') ? '/messaging/messages' : window.location.href.includes('/messageDetail') && '/messaging/messages');
        }, 600);
      }}/>
    )
  }

  downloadDocumentsById=(id, name)=>{
    fetch(config.baseUrl+'storage-api/documents/' + id + '/download',
    {
        method: 'GET',
        headers: {
        'Authorization': Autoload.Utils.getAuthToken()
        }
    })
    .then(response => {
        response.blob()
        .then(data => {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        
        let url = window.URL.createObjectURL(data);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        })
    }).catch((e)=> console.log('document_download_failure: ', e))
}

  render() {
    const {message} = this.props.location.state;
    const {openRecipientStatus, openPreviewModal, openSelectMessageRecipientToPrintModal, selectedRecipient, isMobile, selectedMessageErrorPopover, scrollX, maxScrollX, hover, openBulkMessageDownloadModal, selectedMessageForBulkDownload} = this.state;
    const {accountData} = this.props;
    console.log('message: ', message);
    console.log('isMobile: ', isMobile, window.innerWidth <= MOBILE_SIZE);
    console.log('scrollX: ', scrollX);
    return (
      <div className="messages-list-screen">
        <div>
          <Stack>
            <Group justify="space-between">
              <span className='message-card-time'>{dayjs(message.updatedOn).format('DD.MM.YYYY') === dayjs().format('DD.MM.YYYY') ? `heute (${dayjs.utc(message.updatedOn, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS').tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('HH:mm')} Uhr)` : dayjs.utc(message.updatedOn, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS').tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('DD.MM.YYYY')}</span>
              <div>
                <ColorButton
                text={'Zurück'}
                className={'gray-btn'}
                onClick={()=> this.props.history.goBack()}
                />
              </div>
            </Group>
            <Group><div className='message-card-title' dangerouslySetInnerHTML={{__html: message.subject}} /></Group>
            <Group style={{background: 'white', padding: '30px 20px', borderRadius: '4px', border: '1px solid rgb(218, 218, 229)', marginBottom: '10px'}}><div className='message-detail-body' dangerouslySetInnerHTML={{__html: message.body}} /></Group>
            {(message.templateType !== 'General' && message.documentId !== null) && <div className='divider' />}
            {(message.templateType !== 'General' && message.documentId !== null) &&
            <Stack gap={20}>
                <Group><span className='message-card-title'>1 Anhang</span></Group>
                <Group>
                    <Group onClick={()=> this.downloadDocumentsById(message.documentId, `${message.subject.replace(/<\/?[^>]+(>|$)/g, "")}`)} onMouseEnter={()=> this.setState({hover: 'file1'})} onMouseLeave={()=> this.setState({hover: null})} style={{cursor: 'pointer'}} gap={5} justify={'center'} wrap="nowrap" align='center'>
                        {hover === 'file1' ?
                        <SaveAltIcon 
                        style={{
                        color: '#5655FE',
                        fontSize: '20px'
                        }}/>
                        :
                        <DescriptionIcon 
                        style={{
                        color: '#5655FE',
                        fontSize: '20px'
                        }}/>}
                        <span className='message-card-title' style={{textOverflow: 'ellipsis', overflowX: 'hidden', whiteSpace: 'nowrap'}}>{`${message.subject.replace(/<\/?[^>]+(>|$)/g, "")}`}</span>
                    </Group>
                </Group>
            </Stack>}
            </Stack>
          {openPreviewModal &&
          <MessagePostviewModal
          open={openPreviewModal}
          toggle={()=> this.setState({openPreviewModal: false})}
          isMobile={isMobile}
          allRecipients={message.recipients}
          messageData={message}
          senderAddress={(!accountData.addressCompany || !accountData.addressStreet || !accountData.addressZipCode || !accountData.addressCity) ? <span style={{color: '#dc3545', fontWeight: '500'}}>Absenderadresse unvollständig</span> : ` ${accountData.addressCompany+','} ${accountData.addressStreet+','} ${accountData.addressZipCode} ${accountData.addressCity}`}
          senderEmail={accountData.companyEmail}
          billingPeriod={null}
          selectedRecipient={selectedRecipient}
          />}
          {openSelectMessageRecipientToPrintModal &&
          <SelectMessageRecipientToPrint
          recipients={message.recipients}
          open={openSelectMessageRecipientToPrintModal}
          onPrint={(selectedRecipient)=> {
            let newWindow = window.open('/messagingPdf', "_blank");
            newWindow.message = message;
            newWindow.recipientId = selectedRecipient;
            this.setState({openSelectMessageRecipientToPrintModal: false});
          }}
          toggle={()=> this.setState({openSelectMessageRecipientToPrintModal: false})}/>}
          {openBulkMessageDownloadModal &&
          <BulkDownloadForMessageModal
          open={openBulkMessageDownloadModal}
          multipleTenants={[]}
          toggle={()=> this.setState({openBulkMessageDownloadModal: false, selectedMessageForBulkDownload: null})}
          allRecipients={selectedMessageForBulkDownload?.recipients}
          messageData={selectedMessageForBulkDownload}
          senderAddress={''}
          senderEmail={''}
          billingPeriod={''}
          isMobile={isMobile}
          postMessageDownload={true}
          />}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
      currentDataId: state.UtilityBillingReducer.currentBillingId,
      propertySelected: state.generalReducer.property,
      rentalUnits: state.tenantDataReducer.rentalUnits,
      currentSubscription: state.generalReducer.currentSubscription,
      accountData: state.generalReducer.accountData,
      profile: state.generalReducer.profile,
      profileData: state.generalReducer.profile
  };
};
export default connect(mapStateToProps)(TenantMessageDetail);
